import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classnames from 'classnames';
import { cmxRuntime } from '@codametrix/ui-common';
import { registerVisibilityListener } from './page-visibility';
const DEFAULT_PROPS = {
    registerActivity: ()=>{}
};
registerVisibilityListener(document);
const AppShell = (props)=>{
    const allProps = {
        ...DEFAULT_PROPS,
        ...props
    };
    const { children, registerActivity, className, ...spreadable } = allProps;
    const classNames = classnames([
        className,
        `cmx-app`,
        'cmx-application-masked',
        'cmx-application-loading',
        // calling this cmx-application-chakra had side effects
        {
            'cmx-application-new-design': cmxRuntime.runtimeOverrides?.newAdminDesign
        }
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ...spreadable,
        className: classNames,
        onMouseDown: registerActivity,
        onKeyPress: registerActivity,
        children: /*#__PURE__*/ _jsx("div", {
            className: "layout-main",
            children: /*#__PURE__*/ _jsx("main", {
                className: "content-container max-dimensions",
                children: children
            })
        })
    });
};
export { AppShell };
